import { Checkbox,Slider } from '@fluentui/react-northstar';
import { ShieldOutlined } from '@mui/icons-material';
import { Tabs, Select, Button, Card, Space, Typography, Row, Col } from 'antd';

const { Text } = Typography;
const { Option } = Select;
const { TabPane } = Tabs;

const Settings = () => {
  return (
    <Card>
      <Tabs defaultActiveKey="general">
        <TabPane tab="General" key="general">
          <Row gutter={24}>
            <Col span={12}>
              <div style={{ marginBottom: 24 }}>
                <Text strong style={{ fontSize: 16, display: 'block', marginBottom: 16 }}>
                  Grading Preferences
                </Text>
                <Space direction="vertical" style={{ width: '100%' }} size="large">
                  <div>
                    <Text style={{ display: 'block', marginBottom: 8 }}>Default Feedback Tone</Text>
                    <Select style={{ width: '100%' }}>
                      <Option value="formal">Formal</Option>
                      <Option value="encouraging">Encouraging</Option>
                      <Option value="concise">Concise</Option>
                      <Option value="constructive">Constructive</Option>
                    </Select>
                  </div>

                  <div>
                    <Text style={{ display: 'block', marginBottom: 8 }}>Default Grade Scale</Text>
                    <Select style={{ width: '100%' }}>
                      <Option value="letter">Letter Grades (A-F)</Option>
                      <Option value="percentage">Percentage (0-100%)</Option>
                      <Option value="points">Points (Custom)</Option>
                      <Option value="standards">Standards-Based</Option>
                    </Select>
                  </div>

                  <div>
                    <Text style={{ display: 'block', marginBottom: 8 }}>Default Confidence Threshold</Text>
                    <Slider fluid defaultValue={50} min={0} max={100} />
                    <Row justify="space-between">
                      <Text type="secondary" style={{ fontSize: 12 }}>Show all suggestions</Text>
                      <Text type="secondary" style={{ fontSize: 12 }}>Only high confidence (70%)</Text>
                      <Text type="secondary" style={{ fontSize: 12 }}>Only very high confidence</Text>
                    </Row>
                  </div>

                  <div>
                    <Text style={{ display: 'block', marginBottom: 8 }}>Auto-Save Interval</Text>
                    <Select style={{ width: '100%' }} defaultValue="2">
                      <Option value="1">Every 1 minute</Option>
                      <Option value="2">Every 2 minutes</Option>
                      <Option value="5">Every 5 minutes</Option>
                      <Option value="10">Every 10 minutes</Option>
                    </Select>
                  </div>
                </Space>
              </div>
            </Col>

            <Col span={12}>
              <div style={{ marginBottom: 24 }}>
                <Text strong style={{ fontSize: 16, display: 'block', marginBottom: 16 }}>
                  AI Training Preferences
                </Text>
                <Space direction="vertical" style={{ width: '100%' }} size="large">
                  <Checkbox
                    defaultChecked
                    label={
                      <div>
                        <Text strong>Learn from my edits</Text>
                        <div><Text type="secondary">Allow the AI to learn from your modifications to its suggestions</Text></div>
                      </div>
                    }
                  />

                  <Checkbox
                    defaultChecked
                    label={
                      <div>
                        <Text strong>Use my historical grading patterns</Text>
                        <div><Text type="secondary">Analyze your past grading to better match your style</Text></div>
                      </div>
                    }
                  />

                  <Checkbox
                    label={
                      <div>
                        <Text strong>Share anonymized data to improve AI</Text>
                        <div><Text type="secondary">Help improve the system for all educators (student data never shared)</Text></div>
                      </div>
                    }
                  />
                </Space>

                <div style={{ marginTop: 24 }}>
                  <Text strong style={{ fontSize: 16, display: 'block', marginBottom: 16 }}>
                    Privacy & Security
                  </Text>
                  <Space direction="vertical" style={{ width: '100%' }} size="large">
                    <div>
                      <Text style={{ display: 'block', marginBottom: 8 }}>Data Retention</Text>
                      <Select style={{ width: '100%' }} defaultValue="30">
                        <Option value="forever">Keep all data</Option>
                        <Option value="365">Auto-delete after 1 year</Option>
                        <Option value="120">Auto-delete after semester</Option>
                        <Option value="30" >Auto-delete after 30 days</Option>
                      </Select>
                    </div>

                    <div>
                      <Text style={{ display: 'block', marginBottom: 8 }}>Two-Factor Authentication</Text>
                      <Button icon={<ShieldOutlined />}>Enable 2FA</Button>
                    </div>
                  </Space>
                </div>
              </div>
            </Col>
          </Row>

          <Row justify="end" style={{ marginTop: 24 }}>
            <Space>
              <Button>Cancel</Button>
              <Button type="primary">Save Changes</Button>
            </Space>
          </Row>
        </TabPane>

        <TabPane tab="Rubrics" key="rubric">
          <Text>Rubric settings content would go here</Text>
        </TabPane>

        <TabPane tab="Comment Bank" key="comments">
          <Text>Comment bank settings content would go here</Text>
        </TabPane>

        <TabPane tab="Integrations" key="integrations">
          <Text>Integrations settings content would go here</Text>
        </TabPane>

        <TabPane tab="Account" key="account">
          <Text>Account settings content would go here</Text>
        </TabPane>
      </Tabs>
    </Card>
  );
};

export default Settings;

